import React, {useState} from 'react';
import { Award, Plus } from 'lucide-react';
import { Menu, X, Zap } from 'lucide-react';
import logo from './components/logo.png';
import white_logo from './components/white_logo.png';
import { ArrowRight, CheckCircle } from 'lucide-react';
import collage from './components/collage.png'
import { Scan, DollarSign, Camera, RefreshCw, Wifi, PenTool, Loader2, AlertCircle } from 'lucide-react';
import { Database, BarChart3, Shield, Clock, Users } from 'lucide-react';
import bridgiLogo from './components/bridgi.jpg';
import auditDashLogo from './components/auditdash.png';
import { Mail, Phone, MapPin, Send, ExternalLink } from 'lucide-react';
import OfficesMap from './components/OfficesMap';

// import Header from './components/Header.tsx';
// import Hero from './components/Hero.tsx';
// import Certificates from './components/Certificates.tsx';
// import Domains from './components/Domains.tsx';
// import Features from './components/Features.tsx';
// import Solutions from './components/Solutions.tsx';
// import Bridgi from './components/Bridgi.tsx';
// import Stats from './components/Stats.tsx';
// import Contact from './components/Contact.tsx';
// import Footer from './components/Footer.tsx';
// import PrivacyPolicy from './components/PrivacyPolicy.tsx';
import './index.css';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
    subject: '',
    phone: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notice, setNotice] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isSubmitting) return; // Prevent multiple submissions

    setIsSubmitting(true);

    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('company', formData.company);
    formDataToSend.append('subject', formData.subject);
    formDataToSend.append('message', formData.message);
    formDataToSend.append('phone', formData.phone);

    fetch('https://bridgeselect.com.au/php/new.php', {
      method: 'POST',
      body: formDataToSend,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Form submitted successfully:', data);
        setNotice(data);
        if (data.type==='success') {
          setFormData({
            name: '',
            email: '',
            company: '',
            message: '',
            subject: '',
            phone: '',
          });
        }
      })
      .catch((error) => {
        console.error('Error submitting form:', error);
        setNotice({ type: 'error', message: 'Sorry, there was an error sending your message. Please try again.' });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };
  const stats = [
    {
      number: 'Millions',
      label: 'of Certificates Created',
      description: 'STC, BSTC, VEEC, ESC, PRC, REPS and more',
    },
    
    {
      number: 'Thousands',
      label: 'of Active Users',
      description: 'One of the highest concentration of energy efficiency professionals in the country',
    },
    {
      number: 'Near 24/7',
      label: 'System Uptime',
      description: 'Near-continuous operation with almost 99% uptime',
    },
  ];
  const solutions = [
      {
        icon: <Database className="w-8 h-8" />,
        title: 'Comprehensive Data Management',
        description: 'Centralise all your energy efficiency rebates data and requirements with automated workflows and real-time synchronisation.',
      },
      {
        icon: <BarChart3 className="w-8 h-8" />,
        title: 'Reporting',
        description: 'Generate reports and insights to optimise your energy efficiency rebates programs and compliance.',
      },
      {
        icon: <Shield className="w-8 h-8" />,
        title: 'Compliance Assurance',
        description: 'Stay compliant with automated tracking, validation, and reporting for all regulatory requirements.',
      },
      {
        icon: <Clock className="w-8 h-8" />,
        title: 'Real-Time Processing',
        description: 'Process certificates and applications instantly with our high-performance infrastructure.',
      },
      {
        icon: <Users className="w-8 h-8" />,
        title: 'Multi-Trader Collaboration',
        description: 'Enable seamless collaboration across traders to ensure you don\'t miss out on any of the federal and / or state based rebates.',
      },
      {
        icon: <Zap className="w-8 h-8" />,
        title: 'API Integration',
        description: 'Connect with your existing systems through our robust API and integration capabilities.',
      },
    ];
  const features = [
      {
        icon: <Scan className="w-8 h-8" />,
        title: 'Scan and verify panel serial numbers',
        description: 'Scan and verify serial numbers and ensure they\'ve been supplied by the manufacturer.',
      },
      {
        icon: <DollarSign className="w-8 h-8" />,
        title: 'Generate, manage and trade your STCs',
        description: 'Generate certificates, either trade them straightaway or retain their ownership and trade them at a suitable time and price. More $$$ in your pocket.',
      },
      {
        icon: <Camera className="w-8 h-8" />,
        title: 'Take photos with geo-tags and timestamps',
        description: 'Photos taken using the app are geo-tagged, time-stamped and uploaded automatically without having to worry about these details.',
      },
      {
        icon: <RefreshCw className="w-8 h-8" />,
        title: 'Real time collection of information',
        description: 'Bridge Select works in real time and all updates happen without having to refresh the browser or the app.',
      },
      {
        icon: <Wifi className="w-8 h-8" />,
        title: 'Works without the internet',
        description: 'The app works in areas without an internet connection and syncs up as soon as it enters an area with internet connection.',
      },
      {
        icon: <PenTool className="w-8 h-8" />,
        title: 'App & Remote signatures',
        description: 'Get signatures from customers whether they\'re available onsite or not and have signatures integrated seamlessly into requisite paperwork.',
      },
      {
        icon: <Mail className="w-8 h-8" />,
        title: 'Email Notifications & Notes',
        description: 'Get notified of important updates via email and take job notes while interacting with office staff in realtime.',
      },
      {
        icon: <Users className="w-8 h-8" />,
        title: 'One app / portal for everyone',
        description: 'Doesn\'t matter if you\'re an installer, a retailer, a certificate trader, a wholesaler or a manufacturer. Bridge Select is a one stop shop for your business.',
      },
    ];
  const domainList = [
  { name: 'Solar PV', icon: <img src="https://img.icons8.com/ios-filled/100/000000/solar-panel.png" alt="Solar PV" className="w-12 h-12" /> },
  { name: 'Hot Water', icon: <img src="https://img.icons8.com/ios-filled/100/000000/water-heater.png" alt="Hot Water" className="w-12 h-12" /> },
  { name: 'Batteries', icon: <img src="https://img.icons8.com/?size=100&id=1740&format=png&color=000000" alt="Batteries" className="w-12 h-12" /> },
  { name: 'Aircon', icon: <img src="https://img.icons8.com/ios-filled/100/000000/air-conditioner.png" alt="Air Conditioning" className="w-12 h-12" /> },
  { name: 'EV Charger', icon: <img src="https://img.icons8.com/?size=100&id=5RJRTCnO0lf4&format=png&color=000000" alt="EV Charger" className="w-12 h-12" /> },
  { name: 'Display Cabinets', icon: <img src="https://img.icons8.com/?size=100&id=Fkyk726JcUlt&format=png&color=000000" alt="Display Cabinets" className="w-12 h-12" /> },
  { name: 'In-home Displays', icon: <img src='https://img.icons8.com/?size=100&id=77265&format=png&color=000000' alt="In-home Displays" className="w-12 h-12" /> },
  { name: 'Electric Stove', icon: <img src='https://img.icons8.com/?size=100&id=kgy5fj3mijCV&format=png&color=000000' alt="Electric Stove" className="w-12 h-12" /> },
  { name: 'Home Insulation', icon: <img src='https://img.icons8.com/?size=100&id=Olm60onvGhSP&format=png&color=000000' alt="Home Insulation" className="w-12 h-12" /> },
  { name: 'More', icon: <img src="https://img.icons8.com/?size=100&id=nOm6203PCPWJ&format=png&color=000000" alt="More" className="w-12 h-12" /> },
];
   const certificates = [
      {
        code: 'STC',
        name: 'Small-scale Technology Certificates',
        location: 'Nationwide',
        color: 'bg-orange-500',
        icon: <Award className="w-6 h-6" />, 
        domains: ['Solar PV', 'Hot Water'],
      },
      {
        code: 'BSTC',
        name: 'Battery Small-scale Technology Certificates',
        location: 'Nationwide',
        color: 'bg-purple-600',
        icon: <Award className="w-6 h-6" />, 
        domains: ['Batteries'],
      },
      {
        code: 'VEEC',
        name: 'Victorian Energy Efficiency Certificates',
        location: 'Victoria',
        color: 'bg-green-600',
        icon: <Award className="w-6 h-6" />, 
        domains: ['Hot Water', 'Air Conditioning'],
      },
      {
        code: 'ESC',
        name: 'Energy Savings Certificates',
        location: 'New South Wales',
        color: 'bg-emerald-600',
        icon: <Award className="w-6 h-6" />, 
        domains: ['Hot Water', 'Air Conditioning'],
      },
      {
        code: 'PRC',
        name: 'Peak Reduction Certificates',
        location: 'New South Wales',
        color: 'bg-blue-600',
        icon: <Award className="w-6 h-6" />, 
        domains: ['Batteries', 'Air Conditioning', 'Hot Water'],
      },
      {
        code: 'REPS',
        name: 'Retailer Energy Productivity Scheme',
        location: 'South Australia',
        color: 'bg-red-600',
        icon: <Award className="w-6 h-6" />, 
        domains: ['Solar PV', 'Hot Water', 'Air Conditioning'],
      },
    ];
  return (
    <div className="min-h-screen">
      <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex justify-between items-center h-16">
                {/* Logo */}
                <div className="flex items-center space-x-2">
                  <img src={logo} alt="Logo" className="w-20" />
                  {/* <span className="text-xl font-bold text-gray-900">Bridge Select</span> */}
                </div>
      
                {/* Desktop Navigation */}
                <nav className="hidden md:flex items-center space-x-8">
                  <a href="#solutions" className="text-gray-600 hover:text-green-700 transition-colors">
                    Solutions
                  </a>
                  <a href="#certificates" className="text-gray-600 hover:text-green-700 transition-colors">
                    Certificates
                  </a>
                  <a href="#features" className="text-gray-600 hover:text-green-700 transition-colors">
                    Features
                  </a>
                  <a href="#contact" className="bg-gradient-to-r from-green-600 via-emerald-500 to-teal-500 text-white px-4 py-2 rounded-lg shadow-sm hover:shadow-md hover:from-green-700 hover:via-emerald-600 hover:to-teal-500 transition-colors">
                    Get Started
                  </a>
                </nav>
      
                {/* Mobile menu button */}
                <button
                  className="md:hidden p-2"
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                  {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                </button>
              </div>
      
              {/* Mobile Navigation */}
              {isMenuOpen && (
                <div className="md:hidden py-4 border-t border-gray-200">
                  <div className="flex flex-col space-y-4">
                    <a href="#solutions" className="text-gray-600 hover:text-green-700 transition-colors">
                      Solutions
                    </a>
                    <a href="#certificates" className="text-gray-600 hover:text-green-700 transition-colors">
                      Certificates
                    </a>
                    <a href="#features" className="text-gray-600 hover:text-green-700 transition-colors">
                      Features
                    </a>
                    <a href="#contact" className="text-gray-600 hover:text-green-700 transition-colors">
                      Contact
                    </a>
                    <button className="bg-gradient-to-r from-green-600 via-emerald-500 to-teal-500 text-white px-4 py-2 rounded-lg shadow-sm hover:shadow-md hover:from-green-700 hover:via-emerald-600 hover:to-teal-500 transition-colors w-fit">
                      Get Started
                    </button>
                  </div>
                </div>
              )}
            </div>
          </header>
          <section className="pt-20 pb-16 bg-gradient-to-br from-green-50 to-emerald-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                  <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div>
                      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
                        The platform of choice for the{' '}
                        <span className="bg-gradient-to-r from-green-600 via-emerald-500 to-teal-400 bg-clip-text text-transparent">energy efficiency</span>{' '}rebates industry
                      </h1>
                      <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                        Streamline your energy efficiency programs with our comprehensive platform. 
                        Manage certificates, compliance reporting, and trading with enterprise-grade 
                        reliability, scalability and ease-of-use.
                      </p>
                      
                      <div className="flex flex-col sm:flex-row gap-4 mb-8">
                        <a href="#contact" className="bg-gradient-to-r from-green-600 via-emerald-500 to-teal-500 text-white px-8 py-4 rounded-lg shadow-md hover:shadow-lg hover:from-green-700 hover:via-emerald-600 hover:to-teal-500 transition-all transform hover:scale-105 flex items-center justify-center space-x-2 font-semibold">
                          <span>Get Started Today</span>
                          <ArrowRight className="w-5 h-5" />
                        </a>
                        
                      </div>
          
                      <div className="flex flex-wrap gap-6">
                        <div className="flex items-center space-x-2">
                          <CheckCircle className="w-5 h-5 text-emerald-600" />
                          <span className="text-gray-600">No setup cost</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <CheckCircle className="w-5 h-5 text-emerald-600" />
                          <span className="text-gray-600">Pay for only what you use</span>
                        </div>
                        {/* <div className="flex items-center space-x-2">
                          <CheckCircle className="w-5 h-5 text-emerald-600" />
                          <span className="text-gray-600">Real-time updates</span>
                        </div> */}
                      </div>
                    </div>
          
                    <div className="relative">
                      <div className="relative z-10 bg-white rounded-2xl shadow-2xl p-8">
                        <img
                          src={collage}
                          alt="Solar energy efficiency dashboard"
                          className="w-full h-73 object-cover rounded-lg"
                        />
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-r from-green-600 to-emerald-600 rounded-2xl transform rotate-6 -z-10"></div>
                    </div>
                  </div>
                </div>
              </section>
              <section id="certificates" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {/* Certificates We Assist in Managing */}
            Trade or Register your own Certificates
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto mb-8">
            Super flexible and works seamlessly across a wide variety of certificates and industry verticals. You can work with multiple rebate companies all within the comfort of a single login.
          </p>
        
        </div>

        <div className="bg-green-50 rounded-2xl p-8">
          {/* <h3 className="text-2xl font-bold text-gray-900 mb-10 text-center">
            
          </h3> */}
          
          <div className="mb-8">
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {certificates.map((cert, index) => (
                <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all p-6 border border-gray-100">
                  <div className="flex items-center justify-between mb-4">
                    <div className={`${cert.color} text-white p-3 rounded-lg`}> 
                      {cert.icon}
                    </div>
                    <span className="text-sm font-medium text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
                      {cert.location}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {cert.code}
                  </h3>
                  <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                    {cert.name}
                  </p>
                  <div className="space-y-2">
                    <div className="text-sm font-medium text-gray-700 mb-2">Supported Domains:</div>
                    <div className="flex flex-wrap gap-2">
                      {cert.domains.map((domain, domainIndex) => (
                        <span key={domainIndex} className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded-md">
                          {domain}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
              {/* Coming Soon Card */}
              {/* <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 border-dashed">
                <div className="flex items-center justify-center mb-4">
                  <div className="bg-gray-200 text-gray-400 p-3 rounded-lg">
                    <Plus className="w-6 h-6" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-400 mb-2 text-center">
                  More Coming Soon
                </h3>
                <p className="text-gray-400 text-sm text-center">
                  Additional certificate types and domains will be added to expand our comprehensive coverage.
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
     <section id="domains" className="py-20 bg-gradient-to-br from-emerald-50 to-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Powering Home Electrification Across Diverse Industry Verticals</h2>
        <p className="text-xl text-gray-600 max-w-4xl mx-auto mb-8">
          Our platform supports a wide range of clean energy domains, helping you manage installation, compliance and certificates across these verticals all within the <span className='font-bold'>same login</span>.
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-10 justify-items-center">
        {domainList.map((domain, idx) => (
          <div key={idx} className="relative flex flex-col items-center bg-white rounded-2xl shadow-lg p-6 transition-transform hover:scale-105 w-44">
            {(['EV Charger', 'Home Insulation', 'Electric Stove'].includes(domain.name)) && (
              <span className="absolute top-2 right-2 text-[12px] font-semibold bg-green-100 text-green-800 border border-green-300 rounded-full px-2 py-0.5">
                Soon
              </span>
            )}
            <div className="mb-4">{domain.icon}</div>
            <span className="text-2xl font-bold bg-gradient-to-r from-green-700 via-emerald-600 to-teal-500/90 bg-clip-text text-transparent mb-1 tracking-wide">{domain.name}</span>
          </div>
        ))}
      </div>
      {/* <div className="mt-8 flex items-center justify-center">
                  <div className="inline-flex items-center space-x-2 text-gray-600">
                    <span className="font-semibold">...and more</span>
                  </div>
                  </div> */}
    </div>
  </section>
  <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Some features of the app & portal
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our platform is bundled with many features to take the pain out of managing your energy efficiency jobs
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="group p-8 bg-gray-50 rounded-xl hover:bg-white hover:shadow-lg transition-all">
              <div className="text-green-700 mb-4 group-hover:scale-110 transition-transform">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
     <section id="solutions" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Comprehensive Energy Efficiency Rebates Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our platform provides everything you need to manage, track, and optimize your energy efficiency rebates programs with enterprise-grade scalability and flexibilty.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {solutions.map((feature, index) => (
            <div key={index} className="group p-8 bg-gray-50 rounded-xl hover:bg-white hover:shadow-lg transition-all">
              <div className="text-green-700 mb-4 group-hover:scale-110 transition-transform">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
    <section id="bridgi" className="relative py-24 bg-gradient-to-br from-emerald-50 to-green-100 overflow-hidden" style={{ minHeight: '500px' }}>
          <style jsx>{`
            @keyframes float1 {
              0%, 100% { transform: translate(0px, 0px); }
              25% { transform: translate(10px, -15px); }
              50% { transform: translate(-5px, -10px); }
              75% { transform: translate(-15px, 5px); }
            }
            @keyframes float2 {
              0%, 100% { transform: translate(0px, 0px); }
              33% { transform: translate(-20px, 10px); }
              66% { transform: translate(15px, -5px); }
            }
            @keyframes float3 {
              0%, 100% { transform: translate(0px, 0px); }
              20% { transform: translate(8px, 12px); }
              40% { transform: translate(-12px, -8px); }
              60% { transform: translate(5px, -15px); }
              80% { transform: translate(-8px, 10px); }
            }
            .particle-1 { animation: float1 8s ease-in-out infinite; }
            .particle-2 { animation: float2 12s ease-in-out infinite; }
            .particle-3 { animation: float3 10s ease-in-out infinite; }
            .particle-1:nth-child(odd) { animation-delay: -2s; }
            .particle-2:nth-child(even) { animation-delay: -4s; }
            .particle-3:nth-child(3n) { animation-delay: -6s; }
            .connection-line {
              position: absolute;
              background: linear-gradient(90deg, rgba(34, 197, 94, 0.3), rgba(34, 197, 94, 0.1));
              height: 1px;
              transform-origin: left center;
              animation: pulse 3s ease-in-out infinite;
            }
            @keyframes pulse {
              0%, 100% { opacity: 0.3; }
              50% { opacity: 0.7; }
            }
          `}</style>
          {/* Animated particle background */}
          <div className="absolute inset-0 z-0">
            {/* Connection lines */}
            <div className="connection-line" style={{ top: '12%', left: '14%', width: '60%', transform: 'rotate(8deg)' }}></div>
            <div className="connection-line" style={{ top: '32%', left: '25%', width: '40%', transform: 'rotate(-15deg)' }}></div>
            <div className="connection-line" style={{ top: '52%', left: '20%', width: '50%', transform: 'rotate(25deg)' }}></div>
            <div className="connection-line" style={{ top: '22%', left: '45%', width: '30%', transform: 'rotate(-8deg)' }}></div>
            <div className="connection-line" style={{ top: '42%', left: '10%', width: '75%', transform: 'rotate(12deg)' }}></div>
            <div className="connection-line" style={{ top: '62%', left: '30%', width: '40%', transform: 'rotate(-20deg)' }}></div>
            <div className="connection-line" style={{ top: '72%', left: '35%', width: '45%', transform: 'rotate(18deg)' }}></div>
            <div className="connection-line" style={{ top: '82%', left: '20%', width: '60%', transform: 'rotate(-10deg)' }}></div>
            
            {/* Particles */}
            <div className="absolute w-4 h-4 bg-green-500 rounded-full opacity-60 particle-1 shadow-lg" style={{ top: '10%', left: '10%', boxShadow: '0 0 20px rgba(34, 197, 94, 0.6)' }}></div>
            <div className="absolute w-2 h-2 bg-green-400 rounded-full opacity-70 particle-2 shadow-md" style={{ top: '20%', left: '80%', boxShadow: '0 0 15px rgba(74, 222, 128, 0.5)' }}></div>
            <div className="absolute w-5 h-5 bg-emerald-400 rounded-full opacity-50 particle-3 shadow-lg" style={{ top: '30%', left: '20%', boxShadow: '0 0 25px rgba(52, 211, 153, 0.7)' }}></div>
            <div className="absolute w-3 h-3 bg-green-600 rounded-full opacity-65 particle-1 shadow-md" style={{ top: '40%', left: '90%', boxShadow: '0 0 18px rgba(22, 163, 74, 0.6)' }}></div>
            <div className="absolute w-4.5 h-4.5 bg-green-300 rounded-full opacity-55 particle-2 shadow-lg" style={{ top: '50%', left: '15%', boxShadow: '0 0 22px rgba(134, 239, 172, 0.5)' }}></div>
            <div className="absolute w-2 h-2 bg-emerald-500 rounded-full opacity-75 particle-3 shadow-md" style={{ top: '60%', left: '75%', boxShadow: '0 0 16px rgba(16, 185, 129, 0.6)' }}></div>
            <div className="absolute w-3.5 h-3.5 bg-green-400 rounded-full opacity-60 particle-1 shadow-lg" style={{ top: '70%', left: '30%', boxShadow: '0 0 20px rgba(74, 222, 128, 0.5)' }}></div>
            <div className="absolute w-3 h-3 bg-green-500 rounded-full opacity-50 particle-2 shadow-md" style={{ top: '80%', left: '85%', boxShadow: '0 0 18px rgba(34, 197, 94, 0.6)' }}></div>
            <div className="absolute w-5 h-5 bg-emerald-300 rounded-full opacity-45 particle-3 shadow-lg" style={{ top: '15%', left: '50%', boxShadow: '0 0 25px rgba(110, 231, 183, 0.4)' }}></div>
            <div className="absolute w-2 h-2 bg-green-600 rounded-full opacity-70 particle-1 shadow-md" style={{ top: '25%', left: '40%', boxShadow: '0 0 15px rgba(22, 163, 74, 0.6)' }}></div>
            <div className="absolute w-3.5 h-3.5 bg-emerald-400 rounded-full opacity-55 particle-2 shadow-lg" style={{ top: '35%', left: '70%', boxShadow: '0 0 20px rgba(52, 211, 153, 0.7)' }}></div>
            <div className="absolute w-3 h-3 bg-green-300 rounded-full opacity-65 particle-3 shadow-md" style={{ top: '45%', left: '5%', boxShadow: '0 0 18px rgba(134, 239, 172, 0.5)' }}></div>
        <div className="absolute w-4.5 h-4.5 bg-green-500 rounded-full opacity-50 particle-1 shadow-lg" style={{ top: '55%', left: '95%', boxShadow: '0 0 22px rgba(34, 197, 94, 0.6)' }}></div>
            <div className="absolute w-2 h-2 bg-emerald-600 rounded-full opacity-75 particle-2 shadow-md" style={{ top: '65%', left: '55%', boxShadow: '0 0 16px rgba(5, 150, 105, 0.6)' }}></div>
            <div className="absolute w-3.5 h-3.5 bg-green-400 rounded-full opacity-55 particle-3 shadow-lg" style={{ top: '75%', left: '25%', boxShadow: '0 0 20px rgba(74, 222, 128, 0.5)' }}></div>
            <div className="absolute w-3 h-3 bg-emerald-300 rounded-full opacity-65 particle-1 shadow-md" style={{ top: '85%', left: '65%', boxShadow: '0 0 18px rgba(110, 231, 183, 0.4)' }}></div>
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-10 items-stretch mb-8">
                      <div className="flex flex-col items-center text-center bg-white/60 backdrop-blur-sm rounded-2xl shadow p-8">
                      <div
                        className="flex items-center justify-center w-28 h-28 rounded-full mb-6 shadow-sm"
                        style={{ backgroundColor: '#fcfcfc' }}
                      >
                        <img src={bridgiLogo} alt="BRIDGI.AI Logo" className="w-23 h-23" />
                      </div>
                      <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">BRIDGI.AI</h2>
                      <p className="text-lg font-semibold mb-4 bg-gradient-to-r from-green-600 via-emerald-500 to-teal-500 bg-clip-text text-transparent">Bridge between intelligence and action</p>
                      <p className="text-md text-gray-600 font-medium">Currently only available for BridgeSelect users.</p>
                      </div>

                      {/* AuditDash */}
              <div className="flex flex-col items-center text-center bg-white/60 backdrop-blur-sm rounded-2xl shadow p-8">
                <div className="flex items-center justify-center w-28 h-28 bg-white rounded-full mb-6 shadow-sm">
                  <img src={auditDashLogo} alt="AuditDash Logo" className="w-16 h-16" />
                </div>
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">AuditDash</h2>
                <p className="text-lg font-semibold mb-2 bg-gradient-to-r from-green-600 via-emerald-500 to-teal-500 bg-clip-text text-transparent">Cost effective and smart asset auditing at scale</p>
                <a
                  href="https://auditdash.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-emerald-700 hover:text-emerald-800 font-semibold"
                  aria-label="Open auditdash.com in a new tab"
                >
                  <span>auditdash.com</span>
                  <ExternalLink className="w-4 h-4" />
                </a>
                {/* <p className="text-md text-gray-600 font-medium">Ask us about early access.</p> */}
              </div>
            </div>
          </div>
        </section>
        <section className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Trusted by Industry Leaders
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Join hundreds of energy efficiency professionals who rely on Bridge Select 
            for their certificate management and compliance needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl sm:text-5xl font-bold mb-2 bg-gradient-to-r from-green-500 via-emerald-400 to-teal-300 text-transparent bg-clip-text">
                {stat.number}
              </div>
              <div className="text-xl font-semibold text-white mb-2">
                {stat.label}
              </div>
              <div className="text-gray-300">
                {stat.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    <section id="contact" className="py-24 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                Get in Touch
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Ready to streamline your energy efficiency operations? Contact us to learn more about Bridge Select.
              </p>
            </div>
    
            <div className="grid lg:grid-cols-2 gap-12">
              {/* Contact Information */}
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>
                <div className="space-y-6">
                  <div className="flex items-center space-x-4">
                    <div className="bg-green-100 p-3 rounded-lg">
                      <Mail className="w-6 h-6 text-green-700" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Email</h4>
                      <p className="text-gray-600">support@bridgeselect.com.au</p>
                    </div>
                  </div>
                  
                  {/* <div className="flex items-center space-x-4">
                    <div className="bg-green-100 p-3 rounded-lg">
                      <Phone className="w-6 h-6 text-green-700" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Phone</h4>
                      <p className="text-gray-600">+61 03 7046 4566</p>
                    </div>
                  </div> */}
                  
                  <div className="flex items-center space-x-4">
                    <div className="bg-green-100 p-3 rounded-lg">
                      <MapPin className="w-6 h-6 text-green-700" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Location</h4>
                      <p className="text-gray-600">PO BOX 4261 NARRE WARREN SOUTH VIC 3805 AUSTRALIA</p>
                    </div>
                  </div>
                </div>

                {/* Offices map-like panel (library-based for stable pins) */}
                <div className="mt-10">
                  <h4 className="text-lg font-semibold text-gray-900 mb-3">Our Offices</h4>
                  <OfficesMap />
                </div>
    
                {/* <div className="mt-8 p-6 bg-green-50 rounded-xl">
                  <h4 className="font-semibold text-gray-900 mb-2">Why Choose Bridge Select?</h4>
                  <ul className="space-y-2 text-gray-600">
                    <li>• Pay for only what you use</li>
                  </ul>
                </div> */}
              </div>
    
              {/* Contact Form */}
              <div>
                <form onSubmit={handleSubmit} className="bg-white p-8 rounded-xl shadow-lg">
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">Send us a Message</h3>
                  {notice && (
                    <div className={`mb-6 flex items-start gap-3 rounded-lg border p-4 ${notice.type === 'success' ? 'bg-green-50 border-green-200 text-green-800' : 'bg-red-50 border-red-200 text-red-800'}`}>
                      {notice.type === 'success' ? (
                        <CheckCircle className="w-5 h-5 mt-0.5" />
                      ) : (
                        <AlertCircle className="w-5 h-5 mt-0.5" />
                      )}
                      <div className="flex-1">{notice.message}</div>
                      <button type="button" onClick={() => setNotice(null)} className="ml-2 font-bold opacity-70 hover:opacity-100">×</button>
                    </div>
                  )}
                  
                  <div className="grid md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                        Full Name *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        placeholder="Your full name"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                        Email Address *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        placeholder="your@email.com"
                      />
                    </div>
                  </div>
    
                  <div className="grid md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                        Phone *
                      </label>
                      <input
                        type="text"
                        id="phone"
                        name="phone"
                        required
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                        placeholder="0 411 123 456"
                      />
                    </div>
                    <div>
    
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                      Company
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      placeholder="Your company name"
                    />
                    </div>
                  </div>
                  <div className="mb-6">
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                      Subject
                    </label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      placeholder="Your subject"
                    />
                  </div>
    
                  <div className="mb-6">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                      Message *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      required
                      rows={5}
                      value={formData.message}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      placeholder="Tell us about your energy efficiency needs..."
                    ></textarea>
                  </div>
    
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-gradient-to-r from-green-600 via-emerald-500 to-teal-500 text-white px-8 py-4 rounded-lg shadow-md hover:shadow-lg hover:from-green-700 hover:via-emerald-600 hover:to-teal-500 transition-colors font-semibold flex items-center justify-center space-x-2 disabled:opacity-60 disabled:cursor-not-allowed"
                    aria-busy={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <Loader2 className="w-5 h-5 animate-spin" />
                        <span>Sending...</span>
                      </>
                    ) : (
                      <>
                        <span>Send Message</span>
                        <Send className="w-5 h-5" />
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
        <footer className="bg-gray-900 text-white">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                  {/* Company Info */}
                  <div>
                    <div className="flex items-center space-x-2 mb-4">
                      {/* <div className="flex items-center justify-center w-8 h-8 bg-green-700 rounded">
                        <Zap className="w-5 h-5" />
                      </div>
                      <span className="text-xl font-bold">Bridge Select</span> */}
                      <img src={white_logo} alt="Logo" className="w-20  mb-2" />
                    </div>
                    {/* <p className="text-gray-300 mb-4">
                      The platform of choice for the energy efficiency rebates industry.
                    </p> */}
                    <div className="space-y-2">
                      <div className="flex items-center space-x-2 text-gray-300">
                        <Mail className="w-4 h-4" />
                        <span>support@bridgeselect.com.au</span>
                      </div>
                      <div className="flex items-center space-x-2 text-gray-300">
                        <MapPin className="w-4 h-4" />
                        <span>Melbourne, Australia</span>
                      </div>
                    </div>
                  </div>
        
                  {/* Solutions */}
                  {/* <div>
                    <h3 className="text-lg font-semibold mb-4">Solutions</h3>
                    <ul className="space-y-2 text-gray-300">
                      <li><a href="#" className="hover:text-white transition-colors">Certificate Management</a></li>
                      <li><a href="#" className="hover:text-white transition-colors">STC Processing</a></li>
                      <li><a href="#" className="hover:text-white transition-colors">Compliance Reporting</a></li>
                      <li><a href="#" className="hover:text-white transition-colors">Analytics Dashboard</a></li>
                    </ul>
                  </div> */}
        
                  {/* Resources */}
                  {/* <div>
                    <h3 className="text-lg font-semibold mb-4">Resources</h3>
                    <ul className="space-y-2 text-gray-300">
                      <li><a href="#" className="hover:text-white transition-colors">Documentation</a></li>
                      <li><a href="#" className="hover:text-white transition-colors">API Reference</a></li>
                      <li><a href="#" className="hover:text-white transition-colors">Support Center</a></li>
                      <li><a href="#" className="hover:text-white transition-colors">Training</a></li>
                    </ul>
                  </div> */}
                  <div></div>
                  <div></div>
                  {/* Company */}
                  <div>
                    <h3 className="text-lg font-semibold mb-4">Company</h3>
                    <ul className="space-y-2 text-gray-300">
                      <li><a href="https://bridgeselect.com.au/privacy-policy.html" className="hover:text-white transition-colors">Privacy Policy</a></li>
                      <li><a href="#" className="hover:text-white transition-colors">Terms of Service (upon login)</a></li>
                    </ul>
                  </div>
                </div>
        
                <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
                  <p>&copy; 2025 Bridge Select. All rights reserved.</p>
                </div>
              </div>
            </footer>
      {/* <Header />
      <Hero />
      <Certificates />
      <Domains />
      <Features />
      <Solutions />
      <Bridgi />
      <Stats />
      <Contact />
      <Footer /> */}
    </div>
  );
}

export default App;
